import { useSelector } from 'react-redux';

export const useAdministrator = () => useSelector((state) => {
  const admin = state.session.user.administrator;
  return admin;
});

/**
 * SuperAdmin check - users with isSuperAdmin attribute.
 * Used for sensitive operations like tag management and provider configuration.
 * To grant superadmin access, set user.attributes.isSuperAdmin = true in database.
 */
export const useSuperAdmin = () => useSelector((state) => {
  const isSuperAdmin = state.session.user?.attributes?.isSuperAdmin;
  return isSuperAdmin === true;
});

export const useManager = () => useSelector((state) => {
  const admin = state.session.user.administrator;
  const manager = (state.session.user.userLimit || 0) !== 0;
  return admin || manager;
});

export const useDeviceReadonly = () => useSelector((state) => {
  const admin = state.session.user.administrator;
  const serverReadonly = state.session.server.readonly;
  const userReadonly = state.session.user.readonly;
  const serverDeviceReadonly = state.session.server.deviceReadonly;
  const userDeviceReadonly = state.session.user.deviceReadonly;
  return !admin && (serverReadonly || userReadonly || serverDeviceReadonly || userDeviceReadonly);
});

export const useRestriction = (key) => useSelector((state) => {
  const admin = state.session.user.administrator;
  const serverValue = state.session.server[key];
  const userValue = state.session.user[key];
  return !admin && (serverValue || userValue);
});

export const useLimitCommand = () => useSelector((state) => {
  const admin = state.session.user?.administrator;
  const serverLimitCommands = state.session.server?.limitCommands;
  const userLimitCommands = state.session.user?.limitCommands;
  return !admin && (!serverLimitCommands && !userLimitCommands);
});
